import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Accordion.scss';

const Accordion = ({ title, items }) => {    
    return (
        <div className="Accordion">
            <h2 className="Accordion__Title">{title}</h2>
            <ul className="Accordion__List">
                    {items.map((item, i) =>
                        <Item key={i} {...item} />
                    )}
            </ul>
        </div>
    );
}

const Item = ({ title, text }) => {
    const [ open, setOpen ] = useState(false)

    const classes = classNames(
        'Accordion__Item',
        {'Accordion__Item--Open': open},
    );

    return (
        <li className={classes}>
            <button 
                className="Accordion__Item__Button"
                aria-expanded={open}
                onClick={() => setOpen(!open)}
            >
                <p className="Accordion__Item__Title">
                    {title}
                </p>
            </button>
            <div 
                className="Accordion__Item__Text wysiwyg" 
                dangerouslySetInnerHTML={{ __html: text }}
            ></div>
        </li>
    )
}

Accordion.propTypes = {
    title: PropTypes.string,
    items: PropTypes.array
};

Accordion.defaultProps = {
    title: '',
    items: []
};

export default Accordion;
